/**
 * VÉRIFICATION DU LIEN MAGIQUE — /membres/verifier?email=...&token=...
 * Échange le token du lien contre une session membre, puis redirige vers /membres.
 */
import { consumeReturnTo } from "../lib/returnTo";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { memberApi } from "../lib/api";
import { CircleNotch, CheckCircle, WarningCircle } from "@phosphor-icons/react";

export default function MembreVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const email = params.get("email");
    const token = params.get("token");
    if (!email || !token) { setState("error"); setMsg("Lien incomplet."); return; }
    memberApi.post("/member/auth/verify", { email, token })
      .then((r) => {
        localStorage.setItem("member_token", r.data.token);
        localStorage.setItem("member_profile", JSON.stringify(r.data.member));
        setState("done");
        const nxt = (params.get("next") || "").replace(/[^a-z]/g, ""); setTimeout(() => navigate(nxt ? `/membres#${nxt}` : consumeReturnTo("/membres")), 700);
      })
      .catch((e) => { setState("error"); setMsg(e?.response?.data?.detail || "Lien invalide ou expiré."); });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="kz-body min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white p-6" data-testid="membre-verify">
      <div className="text-center kz-fade-up">
        {state === "loading" && (<>
          <CircleNotch size={40} className="text-[#D90429] mx-auto animate-spin" />
          <p className="kz-mono text-xs tracking-[0.2em] uppercase text-white/50 mt-6">Vérification de ton accès…</p>
        </>)}
        {state === "done" && (<>
          <CheckCircle size={48} weight="fill" className="text-[#D90429] mx-auto" />
          <p className="kz-display text-2xl mt-5">Accès confirmé</p>
          <p className="kz-mono text-xs tracking-[0.2em] uppercase text-white/50 mt-2">Redirection vers ton espace…</p>
        </>)}
        {state === "error" && (<>
          <WarningCircle size={48} weight="fill" className="text-white/60 mx-auto" />
          <p className="kz-display text-2xl mt-5">{msg}</p>
          <button onClick={() => navigate("/membres")} data-testid="verify-retry-btn"
            className="mt-6 bg-white text-black px-7 py-3 font-bold tracking-wider hover:bg-[#D90429] hover:text-white transition-colors">
            Redemander un lien
          </button>
        </>)}
      </div>
    </div>
  );
}
